import Multiselect from 'vue-multiselect'
import { required, minLength, email } from 'vuelidate/lib/validators'
import { userService } from '../../services/UserService'
import Loading from 'vue-loading-overlay';

export default {
    name: 'UserList',

    components: {
        Multiselect,
        Loading
    },

    data: () => {
        return {
            loading: true,
            currentPage: 1,
            perPage: 10,
            searchFilter: '',
            user: {},
            userRole: {},
            userRoles: []
        }
    },
    validations: {
        user: {
            UserName: {
                required,
                minLength: minLength(4)
            },
            Email: {
                required,
                email
            },
            FullName: {
                required,
                minLength: minLength(5)
            },
            PhoneNumber: {
                required
            },
        }
    },
    computed: {
        isValid() {
            return !this.$v.$anyError
        }
    },

    created() {
        var model = this;

        model.companyTablefields = [
            { key: 'Id', label: '', thStyle: 'width:10%' },
            { key: 'Name', label: 'Companie', thStyle: 'width:90%' },
        ];

        var userPromise = userService.getUser(model.$route.params.id)
            .then(response => {
                model.user = response.data;
            });

        var userRolesPromise = userService.getUserRoles()
            .then(response => {
                model.userRoles = response.data;
            });

        axios.all([userPromise, userRolesPromise])
            .then(axios.spread(function () {
                // Get selected role
                model.userRole = model.getItemByCode(model.userRoles, model.user.Role);
                //
                model.loading = false;
            }));
    },

    methods: {
        validate: function () {
            this.$v.$touch();
            this.$nextTick(() => this.findFirstError());

            return this.isValid;
        },
        chkState: function (val) {
            const field = this.getDescendantProp(this.$v, val);

            return !field.$dirty || !field.$invalid
        },
        //
        getIsActiveBadge(isBlocked) {
            return isBlocked === false ? 'success' : 'secondary';//class
        },
        getIsActiveText(isBlocked) {
            return isBlocked === false ? 'Activ' : 'Inactiv';
        },
        //
        searchChanged: function (data) {

        },
        //
        backButtonClick: function () {
            
            this.$router.push({ name: 'userList'});
        },
        saveUser: function () {
            var model = this;

            if (!model.validate())
                return;

            // Set selected role
            model.user.Role = model.userRole.Code;

            var userPromise = userService.saveUser(model.$route.params.id, model.user)
                .then(response => {
                    // if success go to list
                    this.$router.push({ name: 'userList' });
                })

            axios.all([userPromise])
                .then(axios.spread(function () {
                    model.loading = false;
                }));
        }
    },
}
